import { createContext, useContext } from 'react';

type UserContextValue = {
  userId?: string;
};

const UserContext = createContext<UserContextValue>({});

export const useUser = () => useContext(UserContext);
